import { LoadablePaint } from '@confluence/loadable';

export const ContributorsMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContributorsMacro" */ '../src/ContributorsMacroRenderer.tsx'
			)
		).ContributorsMacroRenderer,
});
